import script from "./FundraisingTalkingPointsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FundraisingTalkingPointsView.vue?vue&type=script&setup=true&lang=js"

import "./FundraisingTalkingPointsView.vue?vue&type=style&index=0&id=3d0dd32d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0dd32d"]])

export default __exports__